import { create } from 'zustand'
import type { AdminAnnouncement } from '../types/admin-announcement'

type AdminDialogType = 'create' | 'update' | 'delete' | null

interface AnnouncementsStoreState {
  // 用户端公告详情弹窗
  detail: {
    isOpen: boolean
    selectedId: string | null
    setOpen: (isOpen: boolean) => void
    setSelectedId: (id: string | null) => void
  }
  // 管理员端弹窗状态
  admin: {
    dialogType: AdminDialogType
    currentRow: AdminAnnouncement | null
    setDialogType: (type: AdminDialogType) => void
    setCurrentRow: (row: AdminAnnouncement | null) => void
  }
}

export const useAnnouncementsStore = create<AnnouncementsStoreState>((set) => ({
  detail: {
    isOpen: false,
    selectedId: null,
    setOpen: (isOpen: boolean) =>
      set((state) => ({ detail: { ...state.detail, isOpen } })),
    setSelectedId: (id: string | null) =>
      set((state) => ({ detail: { ...state.detail, selectedId: id } })),
  },
  admin: {
    dialogType: null,
    currentRow: null,
    setDialogType: (dialogType: AdminDialogType) =>
      set((state) => ({ admin: { ...state.admin, dialogType } })),
    setCurrentRow: (currentRow: AdminAnnouncement | null) =>
      set((state) => ({ admin: { ...state.admin, currentRow } })),
  },
}))
